import React from 'react'
import styled from 'styled-components'
import { CheckBoxWrapper } from './CustomCheckbox'

const RadioBtnWrapper = styled(CheckBoxWrapper)`
   input[type='radio'],
   input[type='checkbox'] {
      & + span {
         &:before {
            border-radius: 50%;
         }
      }
      &:checked + span {
         &:after {
            border-radius: 50%;
         }
      }
   }
`

export const CustomRadioBtn = ({ ...props }) => {
   return (
      <RadioBtnWrapper>
         <input {...props} />
         <span></span>
      </RadioBtnWrapper>
   )
}
